import 'react-toastify/dist/ReactToastify.css';
import Routing from './Routing';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <>
    <Routing/>
    <ToastContainer/>
    </>
  );
}

export default App;

